/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";
import style from "./proyectCard.module.scss";
import web from "../../assets/img/proyectIcon/web.png";
import git from "../../assets/img/proyectIcon/git.png";

function ProyectCard({ data }) {
  const { proyecto } = data;
  const StackCard = ({ prop }) => {
    return <span className={style.stackContainer}>{prop}</span>;
  };
  return (
    <div className={style.cardContainer}>
      <div className={style.imgContainer}>
        <img className={style.imagen} src={proyecto.imgUrl} alt="muestra" />
      </div>
      <div className={style.infoContainer}>
        <div className={style.info}>
          <div className={style.titleContainer}>
            <h5>{`${proyecto.title}`}</h5>
            <span>{`| ${proyecto.type}`}</span>
          </div>
          <p>{proyecto.description}</p>
        </div>
        <div className={style.extraInfo}>
          <h6>STACK</h6>
          {proyecto.stack.map((tecno, i) => (
            <StackCard key={i} prop={tecno} />
          ))}
        </div>
        <div className={style.urlContainer}>
          <div className={style.links}>
            {proyecto.build === "" ? null : (
              <img
                onClick={() => {
                  window.open(proyecto.build, "_blank");
                }}
                className={style.urlBoton}
                src={web}
                alt="webLink"
              />
            )}
            {proyecto.git === "" ? null : (
              <img
                onClick={() => {
                  window.open(proyecto.git, "_blank");
                }}
                className={style.urlBoton}
                src={git}
                alt="webLink"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProyectCard;
